/* global __DEV__ */

import * as Sentry from '@sentry/browser'

function log(level, data, extra) {
  if (!__DEV__)
    if (level === 'error') Sentry.captureException(data, { extra })
    else Sentry.captureMessage(data, { level, extra })
  else console[level](`[Logger] ${data}`, extra) // eslint-disable-line no-console
}

export default {
  info: (data, extra) => log('info', data, extra),
  warning: (data, extra) => log('warning', data, extra),
  error: (data, extra) => log('error', data, extra)
}
